/***
*
*   ONBOARDING LAYOUT
*   Simple layout to focus on user onboarding actions
*
**********/

import React, { useContext } from 'react';
import { ViewContext } from 'components/lib';
import Style from './onboarding.tailwind.js';

// Today's frame. Kept as literal fallbacks so an un-themed form renders exactly as
// it always has — the gradient is an inline style rather than a Tailwind class
// because output.css is pre-compiled and committed, so a runtime colour can never
// be a class.
const DEFAULT_FROM = '#6A6AB8';
const DEFAULT_TO = '#8C66F2';

export function OnboardingLayout(props){

  const context = useContext(ViewContext);
  const brand = context?.brandColor;
  const from = brand?.from || DEFAULT_FROM;
  const to = brand?.to || DEFAULT_TO;

  return (
    <main
      className={ Style.onboarding }
      style={{ backgroundImage: `linear-gradient(to bottom, ${from}, ${to})` }}
    >

      { <props.children {...props.data }/> }

    </main>
  );
}
